<div class="nav-submenu">
    <div class="dropdown-header" style="color: #0B7749; font-size: 1.5rem; padding-top: 0.75rem;" *ngIf="insConfig?.title">
      {{ insConfig?.title }}
    </div>

  <div class="nav-submenu-dropdown" *ngIf="config?.title && config?.visible !== false">
    <div class="dropdown-container">
      <ek-tab-buttons
      [items]="tabItems"
      [selected]="selectedValue"
      [maxItemsVisibility]="config?.maxItemsVisibility || 0"
      [viewType]="'bezel'"
      [showDivider]="false"
      (onSelection)="onTabButtonSelection($event)"
      class="ek-submenu-tab-buttons"
      [attr.data-selected-label]="getSelectedLabel()"
      [style.--selected-label]="getSelectedLabel()">
      </ek-tab-buttons>
    </div>
  </div>
</div>